import { render, staticRenderFns } from "./ContactButton.vue?vue&type=template&id=f97ed026&scoped=true"
import script from "./ContactButton.vue?vue&type=script&lang=js"
export * from "./ContactButton.vue?vue&type=script&lang=js"
import style0 from "./ContactButton.vue?vue&type=style&index=0&id=f97ed026&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97ed026",
  null
  
)

export default component.exports